import NavBar from "../components/nav_bar";
import youTalk from "../assets/images/you_talk.png";
import SystemMessage from "../components/system_message";
import { useNotepadStore } from "../store/notepad";
import t from "../locales";
import profilePicture from "../assets/images/you_talk/profile_picture.png";
import yannick from "../assets/images/you_talk/yannick.png";
import Chat from "../components/chat";
import Notepad from "../components/notepad";

export default function YouTalk() {
  const phonenumberFound = useNotepadStore(
    (state) => state.secrets.phonenumber,
  );

  return (
    <>
      <SystemMessage
        type={phonenumberFound ? "ok" : "notAllowed"}
        text={
          phonenumberFound
            ? t("youtalk_system_message_instructions")
            : t("youtalk_system_message_not_allowed")
        }
      />
      <NavBar icon={youTalk} />
      <div className="you-talk">
        <div className="you-talk__contact">
          <img
            src={phonenumberFound ? yannick : profilePicture}
            alt=""
            className="you-talk__contact-image"
          />
          <div className="you-talk__contact-info">
            <h2 className="you-talk__contact-name">
              {t(
                phonenumberFound
                  ? "youtalk_contact_name"
                  : "youtalk_contact_unknown",
              )}
            </h2>
            <span className="you-talk__status">
              <span
                className="you-talk__status-indicator"
                data-online={phonenumberFound}
              ></span>
              {t(
                phonenumberFound
                  ? "youtalk_contact_status_online"
                  : "youtalk_contact_status_offline",
              )}
            </span>
          </div>
        </div>
        <Chat allowStart={phonenumberFound} />
        <Notepad />
      </div>
    </>
  );
}
